<template>
  <div class="about">
    <h1>This is an about page Yeah!</h1>
  </div>
</template>
